export const SWITCH_TO_PAGE = 'SWITCH_TO_PAGE';
